import React from 'react';
import { SocialLoginButtons } from '../index';
import { isNextendActivated } from '../utils';
import Form from './Form';
import style from './style.module.scss';

export const Signup = React.forwardRef(({ image, loginPage, questionLink, redirectTo, handleClose, ...props }, ref) => (
    <div className={style.block} ref={ref} {...props}>
        <div className={style.top}>
            <div className={style.image}>
                {image && <img src={image.url} alt={image.title} className={style.img} />}
            </div>
            <div className={style.title}>Rejoignez-nous maintenant !</div>
        </div>

        <div className={style.content}>
            <Form redirectTo={redirectTo} />

            {isNextendActivated() ? <div className={style.separator}>ou</div> : <div className={style.littleSpacer} />}

            <SocialLoginButtons />

            <div className={style.alreadyRegistered}>
                <div>Vous avez déjà un compte ?</div>

                <a href={loginPage ?? undefined} className={style.loginLink}>
                    Je me connecte
                </a>

                <a href={questionLink ?? undefined}>Découvrir les règles du jeu</a>
            </div>
        </div>

        <div className={style.skip}>
            <span onClick={handleClose}>Passer</span>
        </div>
    </div>
));
